export default __webpack_public_path__ + "static/TripAdvisorMobile-cf4687ce8f4307155bc78875e7c71597.png";